import { RootState } from '../Store';

export const getIsBackPaddockStaff = (state: RootState): boolean =>
  state.staffReducer.isBackPaddockStaff;
